module.exports = __webpack_public_path__ + "static/background__daily-8c9dc6e0283e1995539236b191e6a651.jpg";